import { render, staticRenderFns } from "./PeriodTagFormDialog.vue?vue&type=template&id=64502530"
import script from "./PeriodTagFormDialog.vue?vue&type=script&lang=js"
export * from "./PeriodTagFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports